<app-generic-table
  [id]="'processed-files-table'"
  [config]="tableConfig"
  [data]="processedList"
  [isLoading]="isLoading"
  [noDataMessage]="noDataFoundText"
  [showPagination]="true"
  [page]="params.page"
  [pageSize]="params.pageSize"
  [totalRegisters]="totalRegisters"
  (sortChange)="onSortChange($event)"
  (pageChange)="changePage($event)"
  >
  <!-- _fileName column template -->
  <ng-template appTableCell="fileName" let-item>
    <span
      [attr.id]="item?.fileName ? 'processed-file-name-' + item.fileName : null"
      [title]="item.fileName"
      class="file-name-text">
      {{ item.fileName }}
    </span>
  </ng-template>

  <!-- status column template -->
  <ng-template appTableCell="status" let-item>
    <app-tag
      [id]="item?.fileName ? 'processed-file-tag-status-' + item.fileName : null"
      [type]="getTagStyle(item)">
      <span class="status-text">
        {{ getTagText(item) }}
      </span>
    </app-tag>
  </ng-template>

  <!-- _action column template -->
  <ng-template appTableCell="_action" let-item>
    @if (hasDownloadLink(item)) {
      <a
        [attr.id]="item?.fileName ? 'processed-file-btn-download-' + item.fileName : null"
        (click)="linkToDownload(item)"
        download="processed-file.xlsx"
        title="Download"
        >
        <mat-icon class="active-button">cloud_download</mat-icon>
      </a>
    }
    @if (!hasDownloadLink(item)) {
      <a
        [attr.id]="item?.fileName ? 'processed-file-btn-rejected-' + item.fileName : null"
        download="rejected-file.xlsx"
        >
        <mat-icon class="inactive-button">cloud</mat-icon>
      </a>
    }
  </ng-template>
</app-generic-table>
